import { CRM_SIGNUP, MARKETING_SIGNUP, SALES_SIGNUP, SERVICE_SIGNUP, CMS_FREE_SIGNUP } from 'growth-onboarding-signup-redirect/constants/signupConstants';
import { Flow } from 'signup-constants/Flow';
import { getFlowKey } from '../routing/getFlowKey';
import { getIntegrationKey } from '../routing/getIntegrationKey';
import { getIsActiveAndAssignedToVariant } from '../store/experiments/selectors';
import { ExperimentKeys } from '../experiments/ExperimentKeys';
import { ExperimentParameterGroup } from '../experiments/ExperimentParameterGroup';
import { HubInterestOption } from 'signup-constants/signupData/HubInterestOption';
import { getSignupDataValue } from '../store/signup-data/selectors';
import { Data } from '../signup-data/DATA';
import { isFlow } from '../utils/isFlow';
export const FlowOnboardingSignup = new Map([[Flow.Marketing, MARKETING_SIGNUP], [Flow.Crm, CRM_SIGNUP], [Flow.Sales, SALES_SIGNUP], [Flow.Service, SERVICE_SIGNUP], [Flow.CmsFree, CMS_FREE_SIGNUP], [Flow.HubspotForStartups, SALES_SIGNUP]]);
const HubInterestToSignupType = new Map([[HubInterestOption.Marketing, MARKETING_SIGNUP], [HubInterestOption.Sales, SALES_SIGNUP], [HubInterestOption.CMS, CMS_FREE_SIGNUP], [HubInterestOption.CustomerService, SERVICE_SIGNUP]]);
export const getRedirectSignupType = state => {
  if (getIsActiveAndAssignedToVariant(state, ExperimentKeys.ACQ0140, [ExperimentParameterGroup.Variant_A, ExperimentParameterGroup.Variant_B]) && isFlow([Flow.Marketing, Flow.Sales, Flow.Service])) {
    return HubInterestToSignupType.get(getSignupDataValue(state, Data.HubInterest));
  }

  const flowKey = getFlowKey();
  const integrationKey = getIntegrationKey();
  const key = flowKey === Flow.Integrations && integrationKey ? integrationKey : flowKey;
  return FlowOnboardingSignup.get(key) || FlowOnboardingSignup.get(Flow.Crm);
};